import { GET_API } from "../../Functionalities/APIs";
import { deliveryDbDetailsUrl } from "../../Constants/apiUrls";

export const searchRiders = async (text) => {
  const result = await GET_API("", `search_text=${encodeURIComponent(text)}`, deliveryDbDetailsUrl);
  const rows = (result && result.data && result.data.results) || [];
  return rows.map((row) => ({
    id: row.id,
    name: row.first_name || "",
    mobile: (row.details && row.details.mobile) || "",
  }));
};

export const riderLabel = (rider) => [rider.name || "Rider", `FDRDLBY${rider.id}`, rider.mobile].filter(Boolean).join(" · ");
